module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-photo-ca399e698dd0d924296ce83307b067f2.jpg";